const baseUrl = `${process.env.REACT_APP_WEB_BASE_URL}/api/`;

const apiUrl = {
  donorRegistartion: 'DonorRegistration/Enroll',
  updateProfile: 'DonorRegistration/Update',
  postDocument: 'DonorRegistration/PostDocument',
  sendCodeForEnroll: 'Mobile/SendCodeForEnroll',
  verifyCode: 'Mobile/VerifyCode'
};

export { baseUrl, apiUrl };
